import { toDayMonthYear } from '../helpers';

const checkExpiryStatus = (date: string) => {
  let isExpired = false;
  let isExpiring = false;

  const currentDate = new Date();
  const expiryDate = new Date(toDayMonthYear(date));

  // handle dates based from currentDate
  const timeDifferenceInMs = expiryDate.getTime() - currentDate.getTime();
  const daysDifference = Math.ceil(timeDifferenceInMs / (1000 * 60 * 60 * 24));
  const isWithin30Days = daysDifference <= 30;

  // same date or past the expiration date
  if (expiryDate <= currentDate) {
    isExpired = true;
    // is within 30 days of expiring
  } else if (isWithin30Days) {
    isExpiring = true;
  }

  return {
    isExpired,
    isExpiring,
  };
};

export default checkExpiryStatus;
